import styles from "./AddAccounts.module.scss"
import down from "../../../../assets/images/downArrow.svg"
import delete_red from "../../../../assets/images/delete_red.svg"
import error_mark from "../../../../assets/images/error_mark.svg"
import InputTag from "../../../../components/Input/InputTag"
import { isValidGST } from "../../../../utils/utils"
import validationError from "../../../../enums/validationError"
import { useSelector } from "react-redux"
import { getAllStates } from "../../../Common/commonSlice"
import FileUploader from "../../../Projects/features/RaiseTicketForm/common/FileUploader/FileUploader"
import MuiAutoComplete from "../../../../components/MuiAutocomplete"
import { Box } from "@mui/material"

type Props = {
    addStates: any
    addfunctions: any
}

const BankDetails = (props: Props) => {
    const { addStates, addfunctions } = props
    const { bankDetails, showBankDetails } = addStates
    const { handleBankChanges, toggleBankDetails, removeBankDetails } =
        addfunctions

    return (
        <div style={{ margin: "5px 0px 15px 0px" }}>
            {bankDetails
                .map((element: any, index: number) => {
                    const isDirty = element.bank_name !== "" || element.account_number !== "" || element.ifsc_code !== "" || element.account_holder_name !== ""
                    return (
                        <div
                            className={`${styles.editProfile_modal__form__flex} ${styles.address_container}`}
                            style={{
                                borderBottom:
                                    index !== bankDetails.length - 1
                                        ? "1px solid #EAEAEA"
                                        : "",
                            }}
                            key={index}>
                            <div className={styles.section3} style={{ padding: "6px" }}>
                                <Box className={styles.title} sx={{
                                cursor: "pointer",
                            }} onClick={() => toggleBankDetails(index)}>
                                    <div className={styles.title}>
                                        BANK DETAIL {index + 1}
                                        {bankDetails?.length > 1 ? (
                                            <div
                                                className={styles.account_remove}
                                                style={{ padding: "0px 16px", cursor: "pointer" }}>
                                                <img
                                                    src={delete_red}
                                                    alt="delete_red"
                                                    onClick={() => removeBankDetails(index)}
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                    <span>
                                        <img
                                            src={down}
                                            alt="down"
                                            style={{
                                                transform: showBankDetails[index] ? "" : "rotate(180deg)",
                                            }}
                                        />
                                    </span>
                                </Box>
                                {showBankDetails[index] && (
                                    <>
                                        <div className={styles.editProfile_modal__form__flex}>
                                          <div>
                                                <label className={styles.editProfile_modal__form__flex__label}>
                                                    Bank Name{isDirty ? "*" : ""}
                                                </label>
                                                <InputTag
                                                    required
                                                    name="bank_name"
                                                    placeholder="Select Bank Name"
                                                    error={!element?.bank_name}
                                                    showError={addStates.toggleError && isDirty}
                                                    value={element?.bank_name || ""}
                                                    onChange={e => handleBankChanges(index, e)}
                                                />
                                            </div>
                                            <div>
                                                <label className={styles.editProfile_modal__form__flex__label}>
                                                    Account Number{isDirty ? "*" : ""}
                                                </label>
                                                    <InputTag
                                                        required
                                                        name="account_number"
                                                        placeholder="Enter Account Number"
                                                        error={!element?.account_number}
                                                        showError={addStates.toggleError && isDirty}
                                                        value={element?.account_number || ""}
                                                        onChange={e => handleBankChanges(index, e)}
                                                    />
                                            </div>
                                            <div style={{ paddingRight: 10 }}>
                                                <div className={styles.editProfile_modal__form__flex__label}>
                                                    IFSC Code{isDirty ? "*" : ""}
                                                </div>
                                                <InputTag
                                                    required
                                                    name="ifsc_code"
                                                    placeholder="Enter IFSC Code"
                                                    value={element?.ifsc_code || ""}
                                                    error={!element?.ifsc_code}
                                                    showError={addStates.toggleError && isDirty}
                                                    onChange={e => handleBankChanges(index, e)}
                                                />
                                            </div>
                                            <div>
                                                <div className={styles.editProfile_modal__form__flex__label}>
                                                    Account Holder Name
                                                </div>
                                                <InputTag
                                                    required
                                                    name="account_holder_name"
                                                    placeholder="Enter Account Holder Name"
                                                    value={element?.account_holder_name || ""}
                                                    onChange={e => handleBankChanges(index, e)}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )
                })}
        </div>
    )
}

export default BankDetails
